import { render } from "./Hotnew.vue?vue&type=template&id=122eacc0&scoped=true"
import script from "./Hotnew.vue?vue&type=script&lang=js"
export * from "./Hotnew.vue?vue&type=script&lang=js"

import "./Hotnew.vue?vue&type=style&index=0&id=122eacc0&scoped=true&lang=css"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122eacc0"]])

export default __exports__